import React from 'react';
import Divider from '../../Shared/UI/Divider/components/Divider';
import { useGroupState } from './GroupContext';

import styles from './GroupDescription.module.scss';

const GroupDescription = () => {
  const state = useGroupState();

  if (state?.loading) {
    return (
      <section id={styles.groupDescriptionSection}>
        <Divider />
        <div id={styles.groupDescriptionLoading} />
      </section>
    );
  }

  if (!state?.group?.description) {
    return null;
  }

  return (
    <section id={styles.groupDescriptionSection}>
      <Divider />
      <h2 className={styles.descriptionHeader}>About</h2>
      <p className={styles.description}>
        {state.group.description}
      </p>
    </section>
  );
};

export default GroupDescription;
